import * as React from 'react';
import { TooltipDesktop } from '@cian/ui-kit/tooltip';
import { UIText2 } from '@cian/ui-kit/typography';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';

import * as style from './SpecificationTooltip.css';

export interface ISpecificationTooltipProps {
  text: string;
}

export const SpecificationTooltip: React.FC<ISpecificationTooltipProps> = props => {
  const { text } = props;

  return (
    <TooltipDesktop
      theme={'white'}
      title={
        <div className={style['tooltip']}>
          <UIText2>{text}</UIText2>
        </div>
      }
    >
      <div className={style['faq-icon']} data-testid="SpecificationTooltip">
        <IconFunctionalInformationCircle16 color={'icon-main-default'} />
      </div>
    </TooltipDesktop>
  );
};
